import React from 'react';

import {StaticImg} from 'app/components/general/StaticImg';

interface Props {
  contentType: 'procedure' | 'proceduregroup' | 'policy' | 'document';
  hashid: string;
  alt?: string;
  className?: string;
  style?: Record<string, string | number>;
}

export function QRCodeImage({
  /* eslint-disable @typescript-eslint/no-unused-vars */
  contentType,
  hashid,
  /* eslint-enable @typescript-eslint/no-unused-vars */
  ...other
}: Props): JSX.Element {
  return <StaticImg {...other} src="images/demo-procedure-qr-code.png" />;
}
